// extracted by mini-css-extract-plugin
export default {"button":"styles_button__C3brN","spinner":"styles_spinner__MkrcU","spin":"styles_spin__16hw0"};